import { actionCreator } from '../common/utils';
import { SessionPing } from '@utils/sessionNotice';

const action = actionCreator('@@notifications');

export const openNotification = action<SessionPing>('OPEN_NOTIFICATION');

export const startNotificationsListener = action<void>('START_NOTIFICATIONS_LISTENER');
